import * as React from 'react';
import MuiTabs from '@mui/material/Tabs';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';
import classNames from 'classnames';

interface IProps {
  value: number | boolean;
  /** Callback som körs när komponenten ändras, <b>Signatur:</b> (event: object, value: number) => void */
  onChange: (value: number) => void;
  indicatorColor?: CommonPropsAndTypes.IndicatorColorType;
  children?: React.ReactNode;
  style?: any;
  variant?: 'scrollable' | 'fullWidth';
  className?: string;
  noBoxShadow?: boolean;
  hideIndicator?: boolean;
  scrollButtons?: boolean | 'auto';
  subtleTabs?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    position: 'relative' as const,
  },
  shadow: {
    boxShadow: theme.shadows[3],
  },
  whiteBgColor: {
    backgroundColor: theme.customProperties.Tabs.IndicatorColor.light,
  },
  indicator: {
    height: theme.spacing(0.5),
  },
  flexContainer: {},
  subtleTabs: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.customProperties.Tabs.divider,
  },
});

/**
 * Tabs gör det enkelt att byta mellan olika vyer
 *
 * se https://material-ui-1dab0.firebaseapp.com/demos/tabs/
 */
export class EDTabs extends React.PureComponent<IProps> {
  render() {
    const {
      indicatorColor,
      classes,
      onChange,
      className,
      noBoxShadow,
      subtleTabs,
      ...rest
    } = this.props;

    return (
      <MuiTabs
        classes={{
          root: classNames(classes.root, className, {
            [classes.shadow]: !noBoxShadow,
            [classes.subtleTabs]: subtleTabs,
          }),
          indicator: classNames(classes.indicator, {
            [classes.whiteBgColor]: indicatorColor === 'white',
          }),
          flexContainer: classes.flexContainer,
        }}
        TabIndicatorProps={{
          style: { display: this.props.hideIndicator ? 'none' : 'block' },
        }}
        indicatorColor={
          indicatorColor === 'white'
            ? undefined
            : indicatorColor === 'secondary'
            ? indicatorColor
            : 'primary'
        }
        onChange={(event: React.ChangeEvent<unknown>, value: any) =>
          onChange(value)
        }
        variant="scrollable"
        {...rest}
        textColor="inherit"
      />
    );
  }
}

export default withStyles(EDTabs, styles);
